import { Fragment } from "react";
import { IEvent, ISetEvent } from "@type/index";
import { setYMDDateFormat } from "@utils/date";

/**
 * 이벤트
 */
export const setEventItem = (item: IEvent): ISetEvent | null => {
    return item && typeof item === 'object' ? {
        ...item,
        url: item?.url?.split('|')[0],
        date: `${setYMDDateFormat(item?.startDate)} ~ ${setYMDDateFormat(item?.endDate)}`
    } : null;
};

export const EventArticle = ({ item }: {item: IEvent}) => {
    const data = setEventItem(item);

    if(!data) {
        return <Fragment />;
    }

    const { url, title, date } = data;

    return <div className="search-item-content">
        <a href={url}>
            <div className="search-item-title" dangerouslySetInnerHTML={{ __html: title }}></div></a>
        <div className="search-item-info">
            <span className="date">{date}</span>
        </div>
    </div>;
};